<template>
  <div class="cov-date-body" >

    <div class="cov-date-monthly">
      <div class="cov-date-previous" @click="nextMonth('pre')">«</div>
      <div class="cov-date-caption" >
        <span @click="showYear"><small>{{checked.year}}</small></span>
        <span @click="showMonth">{{displayInfo.month}}</span>
      </div>
      <div class="cov-date-next" @click="nextMonth('next')">»</div>
    </div>

    <div class="cov-date-box" v-if="showInfo.day">
      <div class="cov-picker-box">
        <div class="week">
          <ul>
            <li v-for="weekie in library.week">{{weekie}}</li>
          </ul>
        </div>
        <div
          class    = "day"
          v-for    = "day in dayList"
          track-by = "$index"
          @click   = "checkDay(day)"
          :class   = "{ 'checked':day.checked, 'unavailable':day.unavailable, 'passive-day': !(day.inMonth) }"
        >
          {{ day.value }}
        </div>
      </div>
    </div>

    <div class="cov-date-box list-box" v-if="showInfo.year">
      <div class="cov-picker-box date-list" id="yearList">
        <div class="date-item" v-for="yearItem in library.year" track-by="$index" @click="setYear(yearItem)">{{yearItem}}</div>
      </div>
    </div>

    <div class="cov-date-box list-box" v-if="showInfo.month">
      <div class="cov-picker-box date-list">
        <div class="date-item" v-for="monthItem in library.month" track-by="$index" @click="setMonth(monthItem)">{{monthItem}}</div>
      </div>
    </div>

  </div>
</template>

<script>
// Npm packages
import moment from 'moment'

// Vuex
import { selectedDay } from 'src/vuex/getters'
import { selectDay } from 'src/vuex/actions/meetingActions'

export default {
  vuex: {
    actions: { selectDay },
    getters: { selectedDay }
  },
  data () {
    return {
      option: {
        type: 'day',
        format: 'DD-MM-YYYY',
        time: '15-09-2016'
      },
      limit: [],
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
        month: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    }
  },
  methods: {
    pad: function pad (n) {
      n = Math.floor(n)
      return n < 10 ? '0' + n : n
    },
    nextMonth: function nextMonth (type) {
      var next = null
      type === 'next' ? next = moment(this.checked.currentMoment).add(1, 'M') : next = moment(this.checked.currentMoment).add(-1, 'M')
      this.showDay(next)
    },
    showDay: function showDay (time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = moment()
      } else {
        this.checked.currentMoment = moment(time, this.option.format)
      }
      this.showOne('day')

      this.checked.year = moment(this.checked.currentMoment).format('YYYY')
      this.checked.month = moment(this.checked.currentMoment).format('MM')
      this.checked.day = moment(this.checked.currentMoment).format('DD')

      this.displayInfo.month = this.library.month[moment(this.checked.currentMoment).month()]

      var days = []
      var currentMoment = this.checked.currentMoment
      var firstDay = moment(currentMoment).date(1).day()

      // gettting previous and next month
      // let currentMonth = moment(currentMoment)
      var previousMonth = moment(currentMoment)
      var nextMonth = moment(currentMoment)
      nextMonth.add(1, 'months')
      previousMonth.subtract(1, 'months')

      var monthDays = moment(currentMoment).daysInMonth()
      var oldtime = this.checked.oldtime
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).date(i)
        })
        if (i === Math.ceil(moment(currentMoment).format('D')) && moment(oldtime, this.option.format).year() === moment(currentMoment).year() && moment(oldtime, this.option.format).month() === moment(currentMoment).month()) {
          days[i - 1].checked = true
        }
        this.checkBySelectDays(i, days)
      }

      if (firstDay === 0) firstDay = 7

      for (var _i = 0; _i < firstDay - 1; _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).date(1).subtract(_i + 1, 'days')
        }
        days.unshift(passiveDay)
      }

      var passiveDaysAtFinal = 42 - days.length
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).add(1, 'months').date(_i2)
        }
        days.push(_passiveDay)
      }

      this.dayList = days
    },
    checkBySelectDays: function checkBySelectDays (d, days) {
      var _this = this

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === moment(day).format('YYYY') && _this.checked.month === moment(day).format('MM') && d === Math.ceil(moment(day).format('D'))) {
          days[d - 1].checked = true
        }
      })
    },
    checkDay: function checkDay (obj) {
      if (obj.unavailable || obj.value === '') {
        return false
      }

      if (!obj.inMonth) {
        this.nextMonth(obj.action)
      }

      this.dayList.map(function (x) {
        x.checked = false
      })
      this.checked.day = this.pad(obj.value)
      obj.checked = true
      this.picked()
    },
    showYear: function showYear () {
      var year = moment(this.checked.currentMoment).year()
      this.library.year = []
      var yearTmp = []
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i)
      }
      this.library.year = yearTmp

      this.showOne('year')

      var self = this
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList')
        listDom.scrollTop = listDom.scrollHeight - 100
        self.addYear()
      })
    },
    showOne: function showOne (type) {
      switch (type) {
        case 'year':
          this.showInfo.day = false
          this.showInfo.year = true
          this.showInfo.month = false
          break
        case 'month':
          this.showInfo.day = false
          this.showInfo.year = false
          this.showInfo.month = true
          break
        case 'day':
          this.showInfo.day = true
          this.showInfo.year = false
          this.showInfo.month = false
          break
        default:
          this.showInfo.day = true
          this.showInfo.year = false
          this.showInfo.month = false
      }
    },
    showMonth: function showMonth () {
      this.showOne('month')
    },
    addYear: function addYear () {
      var _this3 = this

      var listDom = document.getElementById('yearList')
      // let tmp = 0
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this3.library.year.length
          var lastYear = _this3.library.year[len - 1]
          _this3.library.year.push(lastYear + 1)
        }
      }, false)
    },
    setYear: function setYear (year) {
      this.checked.currentMoment = moment(year + '-' + this.checked.month + '-' + this.checked.day)
      this.showDay(this.checked.currentMoment)
    },
    setMonth: function setMonth (month) {
      var mo = this.library.month.indexOf(month) + 1
      if (mo < 10) {
        mo = '0' + '' + mo
      }
      this.checked.currentMoment = moment(this.checked.year + '-' + mo + '-' + this.checked.day)
      this.showDay(this.checked.currentMoment)
    },
    show: function showCheck () {
      if (this.time === '') {
        this.showDay()
      } else {
        this.checked.oldtime = this.time
        this.showDay(this.time)
      }
    },
    picked: function picked () {
      var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min
      this.checked.currentMoment = moment(ctime, 'YYYY-MM-DD HH:mm')
      this.time = moment(this.checked.currentMoment).format(this.option.format)
      this.selectDay({ time: this.time, origin: 'widget' })
    }
  },
  ready () {
    this.show()
  },
  watch: {
    'selectedDay' (selectedDay) {
      if (selectedDay.origin !== 'widget') {
        this.time = moment(selectedDay.time, 'DD-MM-YYYY')
        this.show()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

// TODO stop the !important madness

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
.day.checked {
  background: $green !important;
  color: #FFF !important;
  border-radius: 3px;
}
.cov-date-body {
  margin-bottom : 20px;
  display       : inline-block;
  background    : $green;
  overflow      : hidden;
  position      : relative;
  font-size     : 1em;
  font-weight   : 400;
  min-width     : 300px;
  max-width     : 100%;
}

.cov-picker-box {
  background : #fff;
  width      : 100%;
  display    : inline-block;
  padding    : 20px 1em;
  width      : 100%;
  height     : 250px;
  /*text-align : start!important;*/
}

.cov-picker-box td {
  height     : 24px;
  width      : 24px;
  line-height: 34px;
  color      : #000;
  background : #fff;
  text-align : center;
  cursor     : pointer;
}

.cov-picker-box td:hover {
  background: #E6E6E6;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.day {
  transition    : background-color 50ms;
  width         : 14.2857143%;
  display       : inline-block;
  text-align    : center;
  cursor        : pointer;
  height        : 2em;
  line-height   : 2em;
  color         : #000;
  vertical-align: middle;
}

.week ul {
  margin: 0 0 8px;
  padding: 0;
  list-style: none;
}

.week ul li {
  width: 14.2%;
  display: inline-block;
  text-align: center;
  background: transparent;
  color: #000;
  font-weight: bold;
}

.passive-day{
  color: #bbb;
}

.unavailable {
  color: #ccc;
  cursor: not-allowed;
}

.cov-date-monthly {
  height: 96px;
  background: $green;
}

.cov-date-monthly > div {
  display: inline-block;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  color: #fff;
  height: 96px;
  float: left;
  text-align: center;
  cursor: pointer;
}

.cov-date-previous,
.cov-date-next {
  position: relative;
  width: 20% !important;
  text-indent: -300px;
  overflow: hidden;
  color: #fff;
}

.cov-date-caption {
  width: 60%;
  height: 100%;
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  box-sizing: border-box;
  font-size: 1.5em;
}

.cov-date-caption span:hover {
  color: rgba(255, 255, 255, 0.7);
}

.cov-date-previous:hover,
.cov-date-next:hover {
  background: rgba(255, 255, 255, 0.1);
}

.day:hover {
  background: #EAEAEA;
}

.unavailable:hover {
  background: none;
}

.checked:hover {
  background: darken($green, 5%) !important;
}

.cov-date-next::before,
.cov-date-previous::before {
  width            : 20px;
  height           : 2px;
  text-align       : center;
  position         : absolute;
  background       : #fff;
  top              : 50%;
  margin-top       : -7px;
  margin-left      : -7px;
  left             : 50%;
  line-height      : 0;
  content          : '';
  transform        : rotate(45deg);
}

.cov-date-next::after,
.cov-date-previous::after {
  width      : 20px;
  height     : 2px;
  text-align : center;
  position   : absolute;
  background : #fff;
  margin-top : 6px;
  margin-left: -7px;
  top        : 50%;
  left       : 50%;
  line-height: 0;
  content    : '';
  transform  : rotate(-45deg);
}

.cov-date-previous::after {
  transform: rotate(45deg);
}

.cov-date-previous::before {
  transform: rotate(-45deg);
}

.date-item {
  text-align: center;
  font-size : 20px;
  padding   : 10px 0;
  cursor    : pointer;
}

.date-item:hover {
  background: #e0e0e0;
}

.date-list {
  overflow      : auto;
  vertical-align: top;
  padding       : 0;
}

.cov-vue-date {
  display: inline-block;
  color  : #5D5D5D;
}

.button-box {
  background    : #fff;
  vertical-align: top;
  height        : 50px;
  line-height   : 50px;
  text-align    : right;
  padding-right : 20px;
}

.button-box span {
  cursor : pointer;
  padding: 10px 20px;
}

.watch-box {
  height  : 100%;
  overflow: hidden;
}

.hour-box,
.min-box {
  display   : inline-block;
  width     : 50%;
  text-align: center;
  height    : 100%;
  overflow  : auto;
  float     : left;
}
.hour-box ul,
.min-box ul{
  list-style: none;
  margin  : 0;
  padding : 0;
}

.hour-item, .min-item {
  padding  : 10px;
  font-size: 36px;
  cursor: pointer;
}
.hour-item:hover, .min-item:hover{
  background: #E3E3E3;
}
.hour-box .active, .min-box .active{
  background: #F50057;
  color: #FFF !important;
}
::-webkit-scrollbar {
    width: 2px;
}
::-webkit-scrollbar-track {
    background: #E3E3E3;
}
::-webkit-scrollbar-thumb {
    background: #C1C1C1;
    border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// Calendar.vue?1295d2d7